import { useEffect, useState } from "react";
import api from "../../services/api";
import { toast } from "../../hooks/use-toast";
import { useTranslation } from "react-i18next";

const bilingualFields = ["address", "phone_1", "phone_2", "business_hours"];

const singleFields = ["map_link", "email"];
// Generate bilingual initial state
const generateInitialState = () => {
  const state = {};
  bilingualFields.forEach((field) => {
    state[`${field}_en`] = "";
    state[`${field}_ar`] = "";
  });
  singleFields.forEach((field) => {
    state[field] = "";
  });
  return state;
};

const AdminContactSettings = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState(generateInitialState());

  const loadData = async () => {
    try {
      const res = await api.get("/contact-settings");
      if (res.data) {
        const data = {};

        bilingualFields.forEach((field) => {
          data[`${field}_en`] = res.data[`${field}_en`] || "";
          data[`${field}_ar`] = res.data[`${field}_ar`] || "";
        });

        singleFields.forEach((field) => {
          data[field] = res.data[field] || "";
        });

        setFormData(data);
      }
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Submitting payload:", formData);

    try {
      await api.post("/contact-settings/update", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      toast({ title: t("admin.contact.success") });
    } catch (err) {
      console.error(err);
      toast({
        title: t("admin.contact.errorTitle"),
        description: t("admin.contact.errorDescription"),
        variant: "destructive",
      });
    }
  };

  return (
    <div className="bg-card p-8 rounded-2xl shadow-soft max-w-3xl mx-auto">
      <h2 className="text-2xl font-serif font-bold mb-6">
        {t("admin.contact.title")}
      </h2>

      <form onSubmit={handleSubmit} className="space-y-6">
        {bilingualFields.map((field) => (
          <div key={field}>
            <label className="block text-sm font-medium mb-2 capitalize">
              {t(`admin.contact.fields.${field}`)}
            </label>

            {/* English */}
            <div>
              <label className="text-xs text-muted-foreground">
                {t("admin.contact.english")}
              </label>
              <textarea
                rows={2}
                value={formData[`${field}_en`]}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    [`${field}_en`]: e.target.value,
                  }))
                }
                className="w-full mt-1 px-4 py-3 rounded-xl bg-background border border-border focus:border-primary outline-none"
              />
            </div>

            {/* Arabic */}
            <div>
              <label className="text-xs text-muted-foreground">
                {t("admin.contact.arabic")}
              </label>
              <textarea
                dir="rtl"
                rows={2}
                value={formData[`${field}_ar`]}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    [`${field}_ar`]: e.target.value,
                  }))
                }
                className="w-full mt-1 px-4 py-3 rounded-xl bg-background border border-border focus:border-primary outline-none text-right"
              />
            </div>
          </div>
        ))}
        {singleFields.map((field) => (
          <div key={field}>
            <label className="block text-sm font-medium mb-2 capitalize">
              {t(`admin.contact.fields.${field}`)}
            </label>

            <input
              type="text"
              value={formData[field]}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  [field]: e.target.value,
                }))
              }
              className="w-full px-4 py-3 rounded-xl bg-background border border-border focus:border-primary outline-none"
            />
          </div>
        ))}

        <button type="submit" className="btn-hero w-full">
          {t("admin.contact.updateButton")}
        </button>
      </form>
    </div>
  );
};

export default AdminContactSettings;
